import React from 'react'
import { PropTypes } from 'prop-types'
import { Container, Button, Alert } from '@sainsburys-tech/fable'
import RAMSSafetyPolicy from '../../policyWording/RAMSSafetyPolicy'
import WithFooter from '../Footer'
import LoadingOverlay from '../LoadingOverlay'
import AlreadySignedInModal from '../AlreadySignedInModal'
import redirectUser from '../../utils/routeHelper'
import api from '../../utils/api'
import logger from '../../utils/logger'


class RAMSPolicy extends React.Component {
  constructor(props) {
    super(props)
    const { setHeader, setSignOutHeader } = props
    this.state = {
      gpsError: false,
      responseObj: null
      // ramsPolicyDecline:false
    }
    setHeader()
    setSignOutHeader(false)
  }

  componentDidMount = () => {
    api.getUserState()
      .then((result) => {
        if (result) {
          this.setState({ responseObj: result })
        }
      })
  }


  getFooter = () => (
    <Container size="xl">
      <div className="dsib-firePolicy__footer dsib-firePolicy__footer--twoButtons">
        <div className="dsib-firePolicy__footerInner">
          <Button variant="primary" onClick={this.handleAcceptClick} isFullWidth>Accept</Button>
        </div>
        <div className="dsib-firePolicy__footerInner">
          <Button variant="secondary" onClick={this.handleDeclineClick} isFullWidth>Decline</Button>
        </div>
      </div>
    </Container>
  )

 handleAcceptClick = () => {
   const { responseObj } = this.state
   const { history, setRAMSDecline } = this.props
   const isMerchandiserEnabled = Boolean(
     responseObj
      && responseObj.contractorState
      && responseObj.contractorState.contractor
      && responseObj.contractorState.contractor.isMerchandiserEnabled
   )

   setRAMSDecline('Accept')

   if (isMerchandiserEnabled) {
     history.push('/supplier')
   } else if (window.navigator.geolocation) {
     window.navigator.geolocation.getCurrentPosition(this.locationSuccess, this.locationError)
   }
 }

handleDeclineClick = () => {
  const { history } = this.props

  const { setRAMSDecline } = this.props
  setRAMSDecline('Decline')

  if (window.navigator.geolocation) {
    window.navigator.geolocation.getCurrentPosition(this.locationSuccess, this.locationError)
  }

  // this.setState({ramsPolicyDecline:true})
  // console.log('location.coords.latitude');
  // console.log('location.coords.longitude');
  // console.log('decline button click');
  // console.log('decline button click');
  // console.log('decline button click');
  // console.log('decline button click');
  // console.log('decline button click');
  // history.push('/ramsdecline')
}

  locationSuccess = (location) => {
    const { requestSignIn } = this.props
    requestSignIn(location.coords.latitude, location.coords.longitude)
  }

  locationError = (error) => {
    const { message } = error
    let msg = message
    if (error.code === 2) {
      msg = 'GPS is currently unavailable'
    }

    this.setState({ gpsError: true, gpsErrorText: msg })
  }


  showGPSError = () => {
    const { gpsError, gpsErrorText } = this.state
    if (gpsError) {
      return (
        <div className="dsib-firePolicy__gpsError">
          <Alert status="error" isOpen message={gpsErrorText} />
        </div>
      )
    }
    return ''
  }

  render() {
    const { signInState, history, resetSignIn } = this.props
    return (
      <WithFooter className="dsib-firePolicy" footer={this.getFooter()}>
        <AlreadySignedInModal
          isOpen={signInState.status.alreadySignedIn}
          title="Already Signed In"
          details="You are already signed in"
          okClick={() => {
            resetSignIn()
            redirectUser(history)
          }}
        />
        <Container size="xl">
          <div>
            {this.showGPSError()}
            <RAMSSafetyPolicy />
            {signInState.loading
              && <LoadingOverlay hasBackground text="Signing you in..." />
            }
          </div>
        </Container>
      </WithFooter>
    )
  }
}

RAMSPolicy.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setSignOutHeader: PropTypes.func.isRequired,
  requestSignIn: PropTypes.func.isRequired,
  resetSignIn: PropTypes.func.isRequired,
  setRAMSDecline: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  site: PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    distance: PropTypes.number.isRequired
  }),
  signInState: PropTypes.shape({
    loading: PropTypes.bool.isRequired
  }).isRequired
}

RAMSPolicy.defaultProps = {
  site: null
}

export default RAMSPolicy
